import { FILTER_TYPES } from "../TableFilters.constants";
import type { FilterTypes, TableFiltersProps } from "../TableFilters.type";

// Various filter components
import { TextFilter } from "./TextFilter";
import { NumberFilter } from "./NumberFilter";
import { DateFilter } from "./DateFilter";
import { BooleanFilter } from "./BooleanFilter";
import { SelectFilter } from "./SelectFilter";
import { DateRangeFilter } from "./DateRangeFilter";
import { SingleSelectFilter } from "./SingleSelectFilter";

export const TableFilter = <FilterType extends FilterTypes>({
  type
}: TableFiltersProps<FilterType>) => {
  switch (type) {
    case FILTER_TYPES.TEXT:
      return <TextFilter />;
    case FILTER_TYPES.INTEGER:
      return <NumberFilter isInteger />;
    case FILTER_TYPES.DECIMAL:
      return <NumberFilter />;
    case FILTER_TYPES.DATE:
      return <DateFilter />;
    case FILTER_TYPES.DATE_RANGE:
      return <DateRangeFilter />;
    case FILTER_TYPES.BOOLEAN:
      return <BooleanFilter />;
    case FILTER_TYPES.SELECT:
      return <SelectFilter />;
    case FILTER_TYPES.SINGLE_SELECT:
      return <SingleSelectFilter />;
    default:
      return <TextFilter />;
  }
};
